export default {
  contact: "/contact",
  timeline: "/timeline",
  lockheed: "/timeline/lockheed",
  college: "/timeline/college",
  sandia: "/timeline/sandia",
  stratosphere: "/timeline/stratosphere",
  engagement: "/timeline/engagement",
  drone: "/timeline/drone",
  blowme: "/timeline/blowmeaway",
  daylytes: "/timeline/daylytes",
  daylights: "/timeline/daylights",
};
